import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import './viewer.css';
import VSidebar from './Sidebar';
import { API_BASE as apiBase, authHeaders } from '../config/api';

const VLayout = () => {
  useEffect(() => {
    const loadThemePreference = async () => {
      try {
        const res = await fetch(`${apiBase}/my/theme-preference`, {
          headers: { 'Content-Type': 'application/json', ...authHeaders() }
        });
        const body = await res.json().catch(() => ({}));
        
        if (res.ok && body.theme) {
          applyTheme(body.theme);
        } else {
          applyTheme('light');
        }
      } catch (err) {
        console.error('Error loading theme preference:', err);
        applyTheme('light');
      }
    };

    const applyTheme = (theme) => {
      if (theme === 'dark') {
        document.body.classList.add('dark-mode');
        document.body.classList.remove('light-mode');
      } else {
        document.body.classList.add('light-mode');
        document.body.classList.remove('dark-mode');
      }
    };

    loadThemePreference();
  }, []);

  return (
    <div className="v-layout">
      <VSidebar />
      <div className="v-content">
        <Outlet />
      </div>
    </div>
  );
};

export default VLayout;
